import { createStore } from 'vuex'
import axios from 'axios'
import employee from './employee.js'
import company from './company.js'
import Vuex from 'vuex'
import auth from './auth.js'
import office from './office.js'
import position from './position.js'
import attendance from './attendance.js'
import attendanceType from './attendanceType.js'

export default new Vuex.Store({
  modules: {
    auth,
    company,
    office,
    employee,
    position,
    attendance,
    attendanceType
  },
  state: {
    minimized: false,
    menus: [
      {
        name: 'Dashboard',
        icon: 'chart-2',
        url: '/'
      },
      {
        name: 'Perusahaan',
        icon: 'buildings',
        url: '/company'
      },
      {
        name: 'Office',
        icon: 'building-4',
        url: '/office'
      },
      {
        name: 'Position',
        icon: 'hierarchy',
        url: '/position'
      },
      {
        name: 'Karyawan',
        icon: 'profile-2user',
        url: '/employee'
      },
      {
        name: 'Kehadiran',
        icon: 'timer-1',
        url: '/attendance'
      },
      {
        name: 'Cuti',
        icon: 'document-upload',
        url: '/cuti'
      },
      {
        name: 'Reimburse',
        icon: 'money-send',
        url: '/reimburse'
      },
      {
        name: 'Manajemen User',
        icon: 'user-octagon',
        url: '/user'
      },
      {
        name: 'Pengaturan',
        icon: 'setting-2',
        url: '/setting'
      }
    ],
    // baseUrl: 'http://10.11.1.5:7000'
    baseUrl: process.env.VUE_APP_API_URL,
    auth: {}
  },
  getters: {
  },
  mutations: {
    SET_AUTH(state, data) {
      state.auth = data;
    }
  },
  actions: {
    async getAuthData({ commit }) {
      const preferences = await JSON.parse(localStorage.getItem('preferences'))
      if (preferences) {
        commit('SET_AUTH', preferences.auth)
      }
    }
  }
})
